export default `
mutation createEmptyCart {
  createEmptyCart
}
`
